// extracted by mini-css-extract-plugin
module.exports = {"description":"Location_description__yiWoe","h4":"Location_h4__5k150"};